'use strict';

var _ = require('lodash');
var RuleFactory = function RuleFactory(StrategyCondition, scenarioConstants) {
  function Rule(params) {
    this.name = undefined;
    this.description = undefined;
    this.priority = undefined;
    this.effectiveDate = null;
    this.discontinueDate = null;
    this.status = params.status;
    this.notes = undefined;
    this.linkCriteriaEnabled = false;
    this.primaryCriteria = [new StrategyCondition({})];
    this.primaryCriteriaLevel = params.primaryCriteriaLevel;
    this.linkCriteria = [];
    this.linkCriteriaLevel = params.linkCriteriaLevel;
    this.appliedStrategies = _.isArray(params.appliedStrategies) ? params.appliedStrategies : [];
    this.scenarioName = scenarioConstants.PUBLISHED;
    if (!_.isString(params.flowType) && _.get(params, 'primaryCriteriaLevel.domain') === 'MarketDemandClassGroup') {
      params.flowType = 'BOTH';
    }
    if (_.isString(params.flowType)) {
      params.flowType = formatFlowTypeValue(params.flowType);
    }
    _.assignWith(this, params, paramsAssigningCustomizer);
  }
  function paramsAssigningCustomizer(objValue, srcValue) {
    return !_.isUndefined(srcValue) ? srcValue : objValue;
  }
  function dateLessOrEqual(effectiveDate, discontinueDate) {
    return effectiveDate && (effectiveDate.isBefore(discontinueDate) || effectiveDate.isSame(discontinueDate));
  }
  function formatFlowTypeValue(flowTypeEnum) {
    return flowTypeEnum.search(/FlowType./) === -1 ? 'FlowType.' + flowTypeEnum : flowTypeEnum;
  }
  Rule.prototype.isEqual = function (obj) {
    return _.isEqual(this.name, obj.name);
  };
  Rule.prototype.isValid = function (ruleParam) {
    var ruleToCheck = !_.isUndefined(ruleParam) ? ruleParam : this;
    return !_.isEmpty(ruleToCheck.name) && _.isNumber(ruleToCheck.priority) && !_.isNil(ruleToCheck.effectiveDate) && this.isValidEffectiveDate(ruleToCheck) && ruleToCheck.primaryCriteria.length > 0;
  };
  Rule.prototype.isValidEffectiveDate = function (ruleParam) {
    var ruleToCheck = !_.isUndefined(ruleParam) ? ruleParam : this;
    return !ruleToCheck.discontinueDate || dateLessOrEqual(ruleToCheck.effectiveDate, ruleToCheck.discontinueDate);
  };
  return Rule;
};
RuleFactory.$inject = ['StrategyConditionFactory', 'ScenarioConstants'];
module.exports = RuleFactory;